var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"13","viewBox":"0 0 16 13"}},_vm.$listeners),[_c('path',{attrs:{"fill":"none","stroke":"#56AD60","stroke-width":"3","d":"M1 6.25L5.36 10 14 1"}})])}
var staticRenderFns = []

export { render, staticRenderFns }